import { USER_LOGIN_SUCCESS, USER_LOGOUT } from "../types";

const INITIAL_STATE = {
  token: null,
  isLoggedIn: false,
};

const userAuthReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        token: payload,
        isLoggedIn: true,
      };
    case USER_LOGOUT:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};

export default userAuthReducer;


